import React, { Fragment, useEffect, useState } from 'react'
import { Col, Button, Row } from 'reactstrap';
import moment from 'moment';
import 'moment-timezone';
import { calculateAgeParse } from '../../../Utils/Patient';

const InfoPatient = ({ dataPatient }) => {
    const [showMoreServices, setShowMoreServices] = useState(false);
    const clinica_tipo = JSON.parse(sessionStorage.getItem('centroTipos'));

    return (
        <Fragment>
            {
                dataPatient != null && dataPatient != undefined ?
                    <div style={{ /* border: '1px solid #55e5bb', */ marginTop: 0 }}>
                        <hr style={{ color: '#55e5bb' }}></hr>
                        <Row style={{ padding: '0em .25em' }}>
                            <Col md={6}>
                                <div className='flex-column-start'>
                                    <div><h5> <b>PACIENTE </b>| DATOS BÁSICOS </h5></div>
                                    <div><h5><b>Doc. </b>{dataPatient.tip_documento}-{dataPatient.num_documento}</h5></div>
                                    <div><h5><b>Nombre </b>{dataPatient.fullname} </h5></div>
                                    <div><h5><b>Edad: </b>  {calculateAgeParse(dataPatient.birthday)}</h5> </div>
                                    {clinica_tipo.includes(3) &&
                                        <div><h5><b>Peso: </b> {dataPatient.peso}kg - <b>Talla: </b> {dataPatient.talla}cm - <b>IMC </b> {(dataPatient.peso / (Math.pow((dataPatient.talla / 100), 2))).toFixed(2)}</h5> </div>
                                    }
                                </div>
                            </Col>
                            <Col md={6}>
                                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                                    <div><h5><b>SERVICIOS </b>  </h5> </div>
                                </div>
                                {dataPatient.servicios.map((servicio, index) => {
                                    if (showMoreServices == false && index <= 1) {
                                        return <li key={index}>{servicio.codigo} - {servicio.nombre}</li>
                                    }
                                    else if (showMoreServices == true) {
                                        return <li key={index}>{servicio.codigo} - {servicio.nombre}</li>
                                    }
                                })}
                                {
                                    showMoreServices == false ? <label style={{ cursor: 'pointer', color: '#4CE1B6' }} onClick={() => { setShowMoreServices(true) }}>
                                        Ver Mas
                                    </label> : <label style={{ cursor: 'pointer', color: '#4CE1B6' }} onClick={() => { setShowMoreServices(false) }}>
                                        Ver Menos
                                    </label>
                                }
                            </Col>
                        </Row>
                        <hr style={{ color: '#55e5bb' }}></hr>
                    </div> : <Fragment>
                        <b className="text-danger text-center">No se encontraron datos del Paciente</b>
                    </Fragment>
            }

        </Fragment>
    )
}

export default InfoPatient